var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "SideMenu",
    {
      attrs: {
        "side-menu-width": "667px",
        title: _vm.title,
        value: _vm.isTopDialog(_vm.componentName),
        "side-menu-auto-scroll-y": "",
        "side-menu-is-block": "",
      },
      on: { "side-menu:click-close": _vm.handleInfoModalClose },
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }